import { addNewMaterial } from '../../actions/reshipment'
import {
  getReshipmentSummaryData,
  getNonSecureMaterialsStatusProps,
} from '../../selectors/reshipment'

const mapStateToProps = (state, ownProps) => {
  const { testWindow } = ownProps
  const { addingMaterial } = getReshipmentSummaryData(state)
  const { fetching } = getNonSecureMaterialsStatusProps(state)
  return {
    testWindow,
    addingMaterial,
    fetching,
  }
}

export default connect(mapStateToProps, { addNewMaterial })(
  ({ testWindow, fetching, addingMaterial, addNewMaterial }) => (
    <button
      type="button"
      className="btn-link cb-small-font-size"
      style={{ float: 'right', marginTop: 0 }}
      onClick={() => {
        addNewMaterial(testWindow)
      }}
      disabled={addingMaterial || fetching}
      aria-describedby={`${testWindow.toLowerCase()}-testing-heading`}
    >
      <span className="cb-glyph cb-plus" aria-hidden="true" /> Add New Material
    </button>
  )
)
